/* tslint:disable */
/* eslint-disable */
/**
 * TOM YARD SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { CreatePierRequest } from '../model'
// @ts-ignore
import type { CreatePierResponse } from '../model'
// @ts-ignore
import type { DeletePierRequest } from '../model'
// @ts-ignore
import type { GetPiersResponse } from '../model'
// @ts-ignore
import type { UpdatePierRequest } from '../model'
/**
 * PiersApi - axios parameter creator
 */
export const PiersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {CreatePierRequest} [createPierRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPier: async (
      createPierRequest?: CreatePierRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/Piers`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createPierRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {DeletePierRequest} [deletePierRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePier: async (
      deletePierRequest?: DeletePierRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/Piers`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        deletePierRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPiers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/Piers`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpdatePierRequest} [updatePierRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePier: async (
      updatePierRequest?: UpdatePierRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/yard/api/Piers`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updatePierRequest,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PiersApi - functional programming interface
 */
export const PiersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PiersApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {CreatePierRequest} [createPierRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createPier(
      createPierRequest?: CreatePierRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatePierResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createPier(
        createPierRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PiersApi.createPier']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {DeletePierRequest} [deletePierRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deletePier(
      deletePierRequest?: DeletePierRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deletePier(
        deletePierRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PiersApi.deletePier']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPiers(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPiersResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPiers(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PiersApi.getPiers']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpdatePierRequest} [updatePierRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updatePier(
      updatePierRequest?: UpdatePierRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updatePier(
        updatePierRequest,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PiersApi.updatePier']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * PiersApi - factory interface
 */
export const PiersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PiersApiFp(configuration)
  return {
    /**
     *
     * @param {CreatePierRequest} [createPierRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPier(
      createPierRequest?: CreatePierRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreatePierResponse> {
      return localVarFp
        .createPier(createPierRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {DeletePierRequest} [deletePierRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePier(
      deletePierRequest?: DeletePierRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deletePier(deletePierRequest, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPiers(options?: RawAxiosRequestConfig): AxiosPromise<GetPiersResponse> {
      return localVarFp.getPiers(options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpdatePierRequest} [updatePierRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePier(
      updatePierRequest?: UpdatePierRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .updatePier(updatePierRequest, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * PiersApi - object-oriented interface
 */
export class PiersApi extends BaseAPI {
  /**
   *
   * @param {CreatePierRequest} [createPierRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public createPier(createPierRequest?: CreatePierRequest, options?: RawAxiosRequestConfig) {
    return PiersApiFp(this.configuration)
      .createPier(createPierRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {DeletePierRequest} [deletePierRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deletePier(deletePierRequest?: DeletePierRequest, options?: RawAxiosRequestConfig) {
    return PiersApiFp(this.configuration)
      .deletePier(deletePierRequest, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getPiers(options?: RawAxiosRequestConfig) {
    return PiersApiFp(this.configuration)
      .getPiers(options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpdatePierRequest} [updatePierRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updatePier(updatePierRequest?: UpdatePierRequest, options?: RawAxiosRequestConfig) {
    return PiersApiFp(this.configuration)
      .updatePier(updatePierRequest, options)
      .then(request => request(this.axios, this.basePath))
  }
}
